import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "./tp-studio-header";
import TPStudioSidebar from "./TPStudioSidebar";

import "../../../assets/topstudio/styles/CardsSprite.css";
import "../../../assets/topstudio/styles/Player.css";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import spriteUrl from "../../../assets/topstudio/styles/svg/sprite.css-d6f47756.svg";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import BetfairCasinoBetslipWeb from "../betfair-games/betfair_casino_betslip_web";
import axiosInstance from "../../../utils/axiosInstance";
import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";
import CasinoWarResult from "../../client/tp-studio/tp-result/CasinoWarResult.jsx";
import { isMobile } from "react-device-detect";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import DusDamResult from "./tp-result/DusDumResult.jsx";
import BgSound from "../../../assets/topstudio/audio/TpbgSound.mp3";

export default function DusDumVirtual() {
  const dispatch = useDispatch();
  const [stakeLimit, setStakeLimit] = useState(0);
  const [open, setOpen] = useState(false);
  const [gameRoundId, setGameRoundId] = useState("");
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [displayLoader, setDisplayLoader] = useState(true);
  const [activeTabIndex, setActiveTabIndex] = useState(1);
  const [soundEnabled, setSoundEnabled] = useState(false);
  const [usersOnline, setUsersOnline] = useState(85);
  const bgAudioRef = useRef(null);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const [resultList, setResultList] = useState([]);

  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);

  const [book1, setBook1] = useState("");
  const [book2, setBook2] = useState("");
  const [book3, setBook3] = useState("");
  const [book4, setBook4] = useState("");
  const [book5, setBook5] = useState("");
  const [book6, setBook6] = useState("");
  const [book7, setBook7] = useState("");
  const [book8, setBook8] = useState("");
  const [book9, setBook9] = useState("");
  const [book10, setBook10] = useState("");
  const [betList, setBetList] = useState([]);
  const [totalBets, setTotalBets] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [resultData, setResultData] = useState([]);
  ///
  const { data, isConnected } = useSocket({
    marketId: null,
    mtype: "virtual",
    type: "dusdum_virtual"
  });
  //console.log("Socket data:", data);

  const payload = data?.data?.data;
  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  const payloadResult = data?.data?.result;
  //console.log("data:", payload); // DO NOT REMOVE

  //let b1 = 0;

  let b7 = 0;
  let b8 = 0;
  let b9 = 0;
  let b10 = 0;
  let l1 = 0;
  let l2 = 0;
  let l3 = 0;
  let l4 = 0;
  let l5 = 0;
  let l6 = 0;
  let betfairOdds = null;
  let cards_desc = "";
  let c1 = "";
  let c2 = "";
  let c3 = "";
  let c4 = "";

  let cardNum1 = 0;
  let cardNum2 = 0;
  let cardNum3 = 0;
  let cardNum4 = 0;
  let resultCardNo = 0;
  let ac1 = "";

  const [roundId, setRoundId] = useState(0);
  const [eventStatus, setEventStatus] = useState("");
  const [timeLeftGame, setTimeLeftGame] = useState("");
  const [suspend1, setSuspend1] = useState("");
  const [betButtonShow, setBetButtonShow] = useState(true);

  const [b1, setB1] = useState(0);
  const [b2, setB2] = useState(0);
  const [b3, setB3] = useState(0);
  const [b4, setB4] = useState(0);
  const [b5, setB5] = useState(0);
  const [b6, setB6] = useState(0);
  const [shownCard, setShownCard] = useState("1");
  const [cardsSettled, setCardsSettled] = useState(false);
  const [winnerRunners, setWinnerRunners] = useState(() =>
    Array(10).fill(false)
  );
  const [lastStatus, setLastStatus] = useState(null);

  const flipTimerRef = useRef(null);
  const cardsSettleTimerRef = useRef(null);
  const revealStartedForRef = useRef(null);

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };
  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  useEffect(() => {
    if (!payload) return;
    setDisplayLoader(false);
    betfairOdds = data.data.data;

    if (lastStatus != payload.evt_status && payload.evt_status === "OPEN") {
      setWinnerRunners(Array(10).fill(false));
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);
    }
    if (lastStatus != payload.evt_status) {
      setLastStatus(payload.evt_status);
    }

    setRoundId(payload?.cat_mid);
    setEventStatus(payload?.evt_status);
    setUsersOnline(payload?.users_online ?? payload?.users_count ?? 85);
    updateUserData(data?.user);
    let timeLeftGame1 = payload?.left_time;

    if (timeLeftGame1 == 1) {
      timeLeftGame1 = 0;
    }
    timeLeftGame1 = parseInt(timeLeftGame1);
    setTimeLeftGame(timeLeftGame1);

    setSuspend1(payload?.suspend1);

    setB1(payload?.b1);
    setB2(payload?.b2);
    setB3(payload?.b3);
    setB4(payload?.b4);
    setB5(payload?.b5);
    setB6(payload?.b6);

    l1 = betfairOdds.l1;
    l2 = betfairOdds.l2;
    l3 = betfairOdds.l3;
    l4 = betfairOdds.l4;
    l5 = betfairOdds.l5;
    l6 = betfairOdds.l6;

    const resultNum = Number(payload?.result) || cardRankToRunner(payload?.ac1);
    if (resultNum >= 1 && resultNum <= 10) {
      setWinnerRunners(
        Array.from({ length: 10 }, (_, i) => i + 1 === resultNum)
      );
    } else {
      setWinnerRunners(Array(10).fill(false));
    }
  }, [payload]);

  useEffect(() => {
    if (!payload?.evt_status) return;

    if (payload.evt_status === "OPEN") {
      clearTimeout(flipTimerRef.current);
      clearTimeout(cardsSettleTimerRef.current);
      revealStartedForRef.current = null;
      setShownCard("1");
      setCardsSettled(false);
      return;
    }

    const status = String(payload.evt_status).toUpperCase();
    if (status !== "CLOSED") return;

    const card = payload?.ac1;
    if (!card || card === "1") return;

    const roundKey = String(card);
    if (revealStartedForRef.current === roundKey) return;
    revealStartedForRef.current = roundKey;

    clearTimeout(flipTimerRef.current);
    clearTimeout(cardsSettleTimerRef.current);
    setShownCard("1");
    setCardsSettled(false);

    let cancelled = false;

    function revealCard() {
      if (cancelled) return;
      setShownCard(card);
      clearTimeout(cardsSettleTimerRef.current);
      cardsSettleTimerRef.current = setTimeout(() => {
        if (!cancelled) setCardsSettled(true);
      }, 1000);
    }

    flipTimerRef.current = setTimeout(revealCard, 300);

    return () => {
      cancelled = true;
      clearTimeout(flipTimerRef.current);
      clearTimeout(cardsSettleTimerRef.current);
    };
  }, [payload?.evt_status, payload?.ac1]);

  function splitCards(imgData) {
    let imgVal = imgData.split("");
    let resultCardVal = imgVal[0];
    if (resultCardVal == "J") {
      resultCardVal = 11;
    }
    if (resultCardVal == "Q") {
      resultCardVal = 12;
    }
    if (resultCardVal == "K") {
      resultCardVal = 13;
    }
    return (resultCardNo = parseInt(resultCardVal));
  }

  const fetchProfile = async () => {
    const { data } = await axiosInstance.get("/profile");
    setProfileData(data);
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };


  const activeTab = async (tab1) => {
    //console.log("TAB CLICKED", tab1);
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      //console.log("CALLING showResultDetail");
      showResultDetail();
    }
  };

  const playBGSoundWithRetry = () => {
    const audio = bgAudioRef.current;
    if (!audio) return;
    audio.play().catch(() => {
      setTimeout(() => audio.play().catch(() => { }), 250);
    });
  };

  const toggleSound = (e) => {
    const on = e.target.checked;
    setSoundEnabled(on);
    if (on) {
      playBGSoundWithRetry();
    } else {
      bgAudioRef.current?.pause();
    }
  };

  function cardRankToRunner(card) {
    if (!card || card === "1") return 0;
    const rank = String(card).slice(0, -2);
    if (rank === "A") return 1;
    const n = Number(rank);
    return n >= 1 && n <= 10 ? n : 0;
  }

  const DUS_DUM_RUNNER_NAMES = [
    "1-Ekka",
    "2-Dukki",
    "3-Thikki",
    "4-Chauki",
    "5-Panji",
    "6-Chakki",
    "7-Satti",
    "8-Atthi",
    "9-Nehli",
    "10-Dassi"
  ];

  const getWinnerTitle = () => {
    const runnerNum = cardRankToRunner(shownCard);
    if (!shownCard || shownCard === "1" || runnerNum < 1) {
      return "Winner";
    }
    return `Winner = ${DUS_DUM_RUNNER_NAMES[runnerNum - 1]}`;
  };

  const displayResult = (index) => {
    let txt = "";
    if (index == 1) {
      txt = "A";
    } else if (index == 2) {
      txt = "B";
    } else {
      txt = "C";
    }
    return txt;
  };

  const runnerClass = (index) =>
    winnerRunners[index] && cardsSettled
      ? "runner-name sussesBg"
      : "runner-name";

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
    return () => {
      clearTimeout(flipTimerRef.current);
      clearTimeout(cardsSettleTimerRef.current);
    };
  }, []);

  /// result detail ///
  const showResultDetail = async () => {
    //console.log("INSIDE showResultDetail");
    let resultObj = {};
    resultObj.game_type = "dusdum_virtual";

    //console.log("Before API call");
    const response = await axiosInstance.post("/teenpatti-results", resultObj);
    //console.log("After API call");
    setResultData(response.data.results_list);
    //console.log("response->", resultData);
    //console.log("RESULT API", response.data);
  };
  /// result detail ///

  /// place bet ///

  const showBetfairBetSlip = (bettype, teamname, price) => {
    let placeBetObject = {
      amount: 0,
      catmid: "",
      market_type: "m",
      game_name: "dusdum_virtual"
    };
    placeBetObject.catmid = roundId;
    //console.log(placeBetObject);
    placeBetObject.odds = price;
    placeBetObject.teamname = teamname;
    placeBetObject.bettype = bettype;
    placeBetObject.game_type = 7;

    setPlaceBetObject(placeBetObject);

    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
    //showBetfairSlipStatus = true;
  };

  const closeBetSlip = () => {
    setShowBetSlip(false);
  };

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;

    try {
      const response = await axiosInstance.post(
        "/dusdum-virtual",
        placeBetObject
      );
      //console.log(response);
      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
        setShowBetSlipPopup(false);
        getBook();
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  const getBook = async () => {
    let bookObject = {};
    bookObject.roundId = roundId; // roundId;
    bookObject.game_type = "dusdum-virtual";
    //console.log(roundId);
    const response = await axiosInstance.post("/tp20-book", bookObject);
    //console.log("response->", response.data);
    ///
    let userbook = response.data.userbook;
    let bet_list = response.data.bets_list;
    if (userbook.length > 0) {
      let book1Val = userbook[0].rnr1s;
      let book2Val = userbook[0].rnr2s;
      let book3Val = userbook[0].rnr3s;
      let book4Val = userbook[0].rnr4s;
      let book5Val = userbook[0].rnr5s;
      let book6Val = userbook[0].rnr6s;
      let book7Val = userbook[0].rnr7s;
      let book8Val = userbook[0].rnr8s;
      let book9Val = userbook[0].rnr9s;
      let book10Val = userbook[0].rnr10s;

      setBook1(book1Val);
      setBook2(book2Val);
      setBook3(book3Val);
      setBook4(book4Val);
      setBook5(book5Val);
      setBook6(book6Val);
      setBook7(book7Val);
      setBook8(book8Val);
      setBook9(book9Val);
      setBook10(book10Val);
    } else {
      setBook1("");
      setBook2("");
      setBook3("");
      setBook4("");
      setBook5("");
      setBook6("");
      setBook7("");
      setBook8("");
      setBook9("");
      setBook10("");
    }

    if (bet_list.length > 0) {
      setTotalBets(bet_list.length);
      setBetList(bet_list);
    } else {
      setBetList([]);
    }

    ///
    return response;
  };

  useEffect(
    (roundId) => {
      getBook();
    },
    [roundId]
  ); // Empty dependency array
  /// place bet ///
  //console.log("resultList:", resultList);

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <div className="dus-dum-scope aviator-scope access-aaa player-scope aviator-bg-black">
      <ClientLayoutWithOutHeader showLoader={false}>
        <div class="details-tabs-wrapper1">
          <div className="main-page">
            <div className="row no-gutters">
              <div className="col-md-12">
                <div className="bodyheight">
                  <div className="wrapper">
                    <TPStudioSidebar open={open} />
                  </div>

                  <div className="lobby-ctn BPGmaindiv">
                    <TpStudioHeader setOpen={setOpen} open={open} />
                    <TpStudioLoader displayLoader={displayLoader} />
                  </div>
                  <div className=" ExMainCardbundle lobby-ctn BPGmaindiv">
                    <div
                      className="right-side-wrapper-row"
                      id="afterAnimation"
                      style={{
                        background: "#000",
                        display: displayLoader ? "none" : ""
                      }}
                    >
                      <div className="row right-side-row">
                        <div className="col-md-12 padding-none-wrapper1">
                          <div className="left-content">
                            <div className="table-wrap">
                              <div className="details-tabs-wrapper1">
                                <div className="row">
                                  <div className="col-md-8 Exgamesbg">
                                    {/*- -*/}
                                    <div
                                      className="col-12 timerDiv2 mob-margin"
                                      style={{ marginBottom: "-24px" }}
                                    >
                                      <div
                                        className="footer-divbpg border-gradient-footer border-gradient-purple-footer"
                                        style={{ height: "45px" }}
                                      >
                                        <div className="col-6 col-md-6 titlebarname inline-block Gameidcol mt-2">
                                          <p style={{ fontSize: "17px" }}>
                                            DUS KA DUM
                                          </p>
                                        </div>
                                        <div
                                          className="col-6 col-md-6 inline-block Gameidcol text-right"
                                          style={{ marginTop: "2px" }}
                                        >
                                          <div
                                            role="group"
                                            aria-label="Second group"
                                            className="btn-group btn-group-sm mr-2"
                                          >
                                            <button
                                              style={{ fontSize: "14px" }}
                                              type="button"
                                              className={
                                                activeTabIndex == 1
                                                  ? "tablink btn btn-primary bbactive"
                                                  : "tablink btn btn-primary"
                                              }
                                              onClick={() => activeTab(1)}
                                            >
                                              Game
                                            </button>
                                            <button
                                              style={{ fontSize: "14px" }}
                                              type="button"
                                              className={
                                                activeTabIndex == 2
                                                  ? "tablink btn btn-primary bbactive"
                                                  : "tablink btn btn-primary"
                                              }
                                              onClick={() => activeTab(2)}
                                            >
                                              Results
                                            </button>
                                            <button
                                              style={{ fontSize: "14px" }}
                                              type="button"
                                              className="tablink btn btn-primary2"
                                              data-toggle="modal"
                                              data-target="#rulesPopup"
                                            >
                                              Rules
                                            </button>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        className="row mt-2"
                                        style={{
                                          display:
                                            activeTabIndex == 1 ? "" : "none"
                                        }}
                                      >
                                        <div className="col-2 col-md-1">
                                          <div className="Connectedclients mt-1">
                                            <i
                                              aria-hidden="true"
                                              className="fa fa-user mr-1"
                                              style={{
                                                fontSize: "14px",
                                                color: "white"
                                              }}
                                            />
                                            <b>
                                              <span
                                                id="UsersCount"
                                                className="number"
                                              >
                                                {usersOnline}
                                              </span>
                                            </b>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {/*- -*/}
                                    <div
                                      id="AlltabData"
                                      style={{
                                        display:
                                          activeTabIndex == 1 ? "" : "none"
                                      }}
                                    >
                                      <div
                                        className="collapse show show-mobile cards-layout blackjack dus-dum-game"
                                        aria-labelledby="headingThree"
                                        data-parent="#video"
                                        style={{
                                          textAlign: "center",
                                          padding: 0,
                                          position: "relative"
                                        }}
                                      >
                                        <audio
                                          ref={bgAudioRef}
                                          src={BgSound}
                                          loop
                                        />
                                        <div className="dus-dum-timer-wrap col-12 timerDiv2">
                                          <div
                                            className="col-12 col-md-2"
                                            style={{
                                              display:
                                                activeTabIndex == 1
                                                  ? ""
                                                  : "none",
                                              marginLeft: "auto"
                                            }}
                                          >
                                            <div class="base-timer bt-mobile">
                                              <svg
                                                viewBox="0 0 100 100"
                                                xmlns="http://www.w3.org/2000/svg"
                                                class="base-timer__svg"
                                              >
                                                <g class="base-timer__circle">
                                                  <circle
                                                    cx="50"
                                                    cy="50"
                                                    r="45"
                                                    class="base-timer__path-elapsed"
                                                  ></circle>{" "}
                                                  <path
                                                    id="base-timer-path-remaining"
                                                    stroke-dasharray="118 283"
                                                    d="
                                                                  M 50, 50
                                                                  m -45, 0
                                                                  a 45,45 0 1,0 90,0
                                                                  a 45,45 0 1,0 -90,0
                                                                "
                                                    class="base-timer__path-remaining ${remainingPathColor} green"
                                                  ></path>
                                                </g>
                                              </svg>{" "}
                                              <span
                                                id="base-timer-label"
                                                class="base-timer__label"
                                              >
                                                {timeLeftGame}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="player dus-dum-winner"
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            paddingTop: "25px",
                                            width: "100%"
                                          }}
                                        >
                                          <span className="name player-dt">
                                            {getWinnerTitle()}
                                          </span>
                                          <div
                                            class="player"
                                            style={{
                                              display: "inline-flex"
                                            }}
                                          >
                                            <div class="player-item">
                                              <div class="player-cards  stood">
                                                <div class="header-title">
                                                  <span class="status"></span>
                                                </div>
                                                <div
                                                  id="BFBCardHandView"
                                                  class="BFBCardHandView"
                                                >
                                                  <div
                                                    id="game-cards1"
                                                    class="BFBCardFanView"
                                                  >
                                                    {shownCard &&
                                                      shownCard !== "1" &&
                                                      (() => {
                                                        let cardImage = `../assets/galaxy/img/cards3/${shownCard}.svg`;
                                                        return (
                                                          <div class="card1">
                                                            <img
                                                              id="RSMImageView"
                                                              src={cardImage}
                                                              class="RSMImageView animate__animated"
                                                            />
                                                          </div>
                                                        );
                                                      })()}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        className="tp20-sound-wrap"
                                        style={{
                                          display:
                                            activeTabIndex == 1 ? "" : "none"
                                        }}
                                      >
                                        <label
                                          htmlFor="DusDumSoundcontrol"
                                          className={`fa fa-inverse sound-icon ${soundEnabled
                                              ? "fa-volume-up"
                                              : "fa-volume-off"
                                            }`}
                                          title="Toggle sound"
                                        >
                                          <input
                                            id="DusDumSoundcontrol"
                                            type="checkbox"
                                            checked={soundEnabled}
                                            onChange={toggleSound}
                                            style={{ display: "none" }}
                                          />
                                        </label>
                                      </div>

                                      <center
                                        style={{
                                          display:
                                            activeTabIndex == 1 ? "" : "none"
                                        }}
                                      >
                                        <div
                                          className="footer-divbpg border-gradient-footer border-gradient-purple-footer"
                                          style={{ marginTop: "10px" }}
                                        >
                                          <div className="buttons-div">
                                            {Object.keys(resultList).map(
                                              (idx) => (
                                                <button
                                                  key={idx}
                                                  className="video-button border-gradient-btn border-gradient-purple-btn"
                                                >
                                                  {resultList[idx]}
                                                </button>
                                              )
                                            )}
                                          </div>
                                          <div className="round-div">
                                            <div className="label">
                                              Round ID:
                                            </div>
                                            <div className="id">{roundId}</div>
                                          </div>
                                        </div>
                                      </center>

                                      {/*- -*/}

                                      <div
                                        className="tb-content"
                                        style={{ background: "#fff" }}
                                      >
                                        <div className="market-titlebar">
                                          <p className="market-name">
                                            <span className="market-name-badge">
                                              <i className="market-name-icon">
                                                <img
                                                  src="/assets/images/time-img.png"
                                                  style={{
                                                    filter: "invert(100%)",
                                                    marginTop: "-8px",
                                                    marginLeft: "-1px"
                                                  }}
                                                />
                                              </i>
                                              <span>MATCH ODDS</span>
                                              {/*-<span style="text-transform: initial;">
                                                          (MaxBet: 5M) </span></span> <span class="rules-badge"><i class="fa fa-info-circle"></i></span>-*/}
                                            </span>
                                          </p>
                                          <div className="market-overarround">
                                            <span />
                                            <strong>Back</strong>
                                          </div>
                                          <div className="market-overarround market-overarround-lay">
                                            <strong>Lay</strong>
                                          </div>
                                        </div>
                                        <div className="market-runners">
                                          <div className="runner-runner">
                                            <h3
                                              className={runnerClass(0)}
                                              id="b1Sucess"
                                            >
                                              <div className="runner-info">
                                                <span className="clippable runner-display-name">
                                                  <table>
                                                    <tbody>
                                                      <tr>
                                                        <td>
                                                          <h4
                                                            style={{
                                                              marginBottom: 0,
                                                              fontSize: 16
                                                            }}
                                                            className="clippable-spacer"
                                                          >
                                                            1-Ekka
                                                          </h4>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td>
                                                          <div
                                                            id="livestat1"
                                                            style={{
                                                              float: "left",
                                                              color: "red"
                                                            }}
                                                          >
                                                            {book1 !== "" ? (
                                                              Number(book1) >
                                                                0 ? (
                                                                <font color="green">
                                                                  {formatTruncate(
                                                                    book1
                                                                  )}
                                                                </font>
                                                              ) : (
                                                                <font color="red">
                                                                  {formatTruncate(
                                                                    book1
                                                                  )}
                                                                </font>
                                                              )
                                                            ) : (
                                                              ""
                                                            )}
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </span>
                                              </div>
                                            </h3>
                                            <div className="price-row-box-new">
                                              <div
                                                className={`runner-disabled2 suspendCls ${isSuspended ? "" : "hides"
                                                  }`}
                                              >
                                                {suspendedText}
                                              </div>
                                              <a className="price-price price-back whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-back whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a
                                                className="price-price price-back mb-show span1details"
                                                data-id="Amar"
                                                data-type="b"
                                                data-sid={1}
                                                data-market-type="m"
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "b",
                                                    "1-Ekka",
                                                    b1
                                                  )
                                                }
                                              >
                                                <div
                                                  id="rnr1"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s01"
                                                  >
                                                    <span>{b1}</span>
                                                  </span>
                                                  <span
                                                    className="price-amount"
                                                    id="rate1"
                                                  >
                                                    {stakeLimit}
                                                  </span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay ml-4 mb-show">
                                                <div
                                                  id="rnr1"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s01"
                                                  ></span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-lay mr-4 whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              {/*<div class="suspended-overlap" id="odds_suspend_runner1">Suspended</div>*/}
                                            </div>
                                          </div>
                                          <div className="runner-runner">
                                            <h3
                                              className={runnerClass(1)}
                                              id="b2Sucess"
                                            >
                                              <div className="runner-info">
                                                <span className="clippable runner-display-name">
                                                  <table>
                                                    <tbody>
                                                      <tr>
                                                        <td>
                                                          <h4
                                                            style={{
                                                              marginBottom: 0,
                                                              fontSize: 16
                                                            }}
                                                            className="clippable-spacer"
                                                          >
                                                            2-Dukki
                                                          </h4>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td>
                                                          <div
                                                            id="livestat2"
                                                            style={{
                                                              float: "left",
                                                              color: "red"
                                                            }}
                                                          >
                                                            {book2 !== "" ? (
                                                              Number(book2) >
                                                                0 ? (
                                                                <font color="green">
                                                                  {formatTruncate(
                                                                    book2
                                                                  )}
                                                                </font>
                                                              ) : (
                                                                <font color="red">
                                                                  {formatTruncate(
                                                                    book2
                                                                  )}
                                                                </font>
                                                              )
                                                            ) : (
                                                              ""
                                                            )}
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                  {/*<span class="favi" id="runner2_fav"
                                                                  style="display:none;padding:3px 7px;border-radius:10px;background:#e2b330;color:white">F</span>*/}
                                                </span>
                                              </div>
                                            </h3>
                                            <div className="price-row-box-new">
                                              <div
                                                className={`runner-disabled2 suspendCls ${isSuspended ? "" : "hides"
                                                  }`}
                                              >
                                                {suspendedText}
                                              </div>
                                              <a className="price-price price-back whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-back whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a
                                                className="price-price price-back mb-show span1details"
                                                data-market-type="m"
                                                data-id="Akbar"
                                                data-type="b"
                                                data-sid={2}
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "b",
                                                    "2-Dukki",
                                                    b2
                                                  )
                                                }
                                              >
                                                <div
                                                  id="rnr2"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s03"
                                                  >
                                                    <span>{b2}</span>
                                                  </span>
                                                  <span
                                                    className="price-amount"
                                                    id="rate2"
                                                  >
                                                    {stakeLimit}
                                                  </span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay ml-4 mb-show">
                                                <div
                                                  id="rnr2"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s03"
                                                  ></span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-lay mr-4 whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                            </div>
                                          </div>
                                          <div className="runner-runner">
                                            <h3
                                              className={runnerClass(2)}
                                              id="b3Sucess"
                                            >
                                              <div className="runner-info">
                                                <span className="clippable runner-display-name">
                                                  <table>
                                                    <tbody>
                                                      <tr>
                                                        <td>
                                                          <h4
                                                            style={{
                                                              marginBottom: 0,
                                                              fontSize: 16
                                                            }}
                                                            className="clippable-spacer"
                                                          >
                                                            3-Thikki
                                                          </h4>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td>
                                                          <div
                                                            id="livestat3"
                                                            style={{
                                                              float: "left",
                                                              color: "red"
                                                            }}
                                                          >
                                                            {book3 !== "" ? (
                                                              Number(book3) >
                                                                0 ? (
                                                                <font color="green">
                                                                  {formatTruncate(
                                                                    book3
                                                                  )}
                                                                </font>
                                                              ) : (
                                                                <font color="red">
                                                                  {formatTruncate(
                                                                    book3
                                                                  )}
                                                                </font>
                                                              )
                                                            ) : (
                                                              ""
                                                            )}
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </span>
                                              </div>
                                            </h3>
                                            <div className="price-row-box-new">
                                              <div
                                                className={`runner-disabled2 suspendCls ${isSuspended ? "" : "hides"
                                                  }`}
                                              >
                                                {suspendedText}
                                              </div>
                                              <a className="price-price price-back whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-back whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a
                                                className="price-price price-back mb-show span1details"
                                                data-id="Anthony"
                                                data-type="b"
                                                data-sid={3}
                                                data-market-type="m"
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "b",
                                                    "3-Thikki",
                                                    b1
                                                  )
                                                }
                                              >
                                                <div
                                                  id="rnr3"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s05"
                                                  >
                                                    <span>{b1}</span>
                                                  </span>
                                                  <span
                                                    className="price-amount"
                                                    id="rate3"
                                                  >
                                                    {stakeLimit}
                                                  </span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay ml-4 mb-show">
                                                <div
                                                  id="rnr3"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s05"
                                                  ></span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay whtBack hide-mobile ">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-lay mr-4 whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              {/*<div class="suspended-overlap" id="odds_suspend_runner2">Suspended</div>*/}
                                            </div>
                                          </div>
                                          <div className="runner-runner">
                                            <h3
                                              className={runnerClass(3)}
                                              id="b4Sucess"
                                            >
                                              <div className="runner-info">
                                                <span className="clippable runner-display-name">
                                                  <table>
                                                    <tbody>
                                                      <tr>
                                                        <td>
                                                          <h4
                                                            style={{
                                                              marginBottom: 0,
                                                              fontSize: 16
                                                            }}
                                                            className="clippable-spacer"
                                                          >
                                                            4-Chauki
                                                          </h4>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td>
                                                          <div
                                                            id="livestat5"
                                                            style={{
                                                              float: "left",
                                                              color: "red"
                                                            }}
                                                          >
                                                            {book4 !== "" ? (
                                                              Number(book4) >
                                                                0 ? (
                                                                <font color="green">
                                                                  {formatTruncate(
                                                                    book4
                                                                  )}
                                                                </font>
                                                              ) : (
                                                                <font color="red">
                                                                  {formatTruncate(
                                                                    book4
                                                                  )}
                                                                </font>
                                                              )
                                                            ) : (
                                                              ""
                                                            )}
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </span>
                                              </div>
                                            </h3>
                                            <div className="price-row-box-new">
                                              <div
                                                className={`runner-disabled2 suspendCls ${isSuspended ? "" : "hides"
                                                  }`}
                                              >
                                                {suspendedText}
                                              </div>
                                              <a className="price-price price-back whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-back whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a
                                                className="price-price price-back mb-show span1details"
                                                data-id="Odd"
                                                data-type="b"
                                                data-sid={5}
                                                data-market-type="f"
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "b",
                                                    "4-Chauki",
                                                    b1
                                                  )
                                                }
                                              >
                                                <div
                                                  id="rnr4"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s08"
                                                  >
                                                    <span>{b1}</span>
                                                  </span>
                                                  <span
                                                    className="price-amount"
                                                    id="rate4"
                                                  >
                                                    {stakeLimit}
                                                  </span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay ml-4 mb-show">
                                                <div
                                                  id="rnr4"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s08"
                                                  ></span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-lay mr-4 whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              {/*<div class="suspended-overlap" id="odds_suspend_runner1">Suspended</div>*/}
                                            </div>
                                          </div>
                                          <div className="runner-runner">
                                            <h3
                                              className={runnerClass(4)}
                                              id="b4Sucess"
                                            >
                                              <div className="runner-info">
                                                <span className="clippable runner-display-name">
                                                  <table>
                                                    <tbody>
                                                      <tr>
                                                        <td>
                                                          <h4
                                                            style={{
                                                              marginBottom: 0,
                                                              fontSize: 16
                                                            }}
                                                            className="clippable-spacer"
                                                          >
                                                            5-Panji
                                                          </h4>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td>
                                                          <div
                                                            id="livestat5"
                                                            style={{
                                                              float: "left",
                                                              color: "red"
                                                            }}
                                                          >
                                                            {book5 !== "" ? (
                                                              Number(book5) >
                                                                0 ? (
                                                                <font color="green">
                                                                  {formatTruncate(
                                                                    book5
                                                                  )}
                                                                </font>
                                                              ) : (
                                                                <font color="red">
                                                                  {formatTruncate(
                                                                    book5
                                                                  )}
                                                                </font>
                                                              )
                                                            ) : (
                                                              ""
                                                            )}
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </span>
                                              </div>
                                            </h3>
                                            <div className="price-row-box-new">
                                              <div
                                                className={`runner-disabled2 suspendCls ${isSuspended ? "" : "hides"
                                                  }`}
                                              >
                                                {suspendedText}
                                              </div>
                                              <a className="price-price price-back whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-back whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a
                                                className="price-price price-back mb-show span1details"
                                                data-id="Odd"
                                                data-type="b"
                                                data-sid={5}
                                                data-market-type="f"
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "b",
                                                    "5-Panji",
                                                    b1
                                                  )
                                                }
                                              >
                                                <div
                                                  id="rnr4"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s08"
                                                  >
                                                    <span>{b1}</span>
                                                  </span>
                                                  <span
                                                    className="price-amount"
                                                    id="rate4"
                                                  >
                                                    {stakeLimit}
                                                  </span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay ml-4 mb-show">
                                                <div
                                                  id="rnr4"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s08"
                                                  ></span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-lay mr-4 whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              {/*<div class="suspended-overlap" id="odds_suspend_runner1">Suspended</div>*/}
                                            </div>
                                          </div>
                                          <div className="runner-runner">
                                            <h3
                                              className={runnerClass(5)}
                                              id="b4Sucess"
                                            >
                                              <div className="runner-info">
                                                <span className="clippable runner-display-name">
                                                  <table>
                                                    <tbody>
                                                      <tr>
                                                        <td>
                                                          <h4
                                                            style={{
                                                              marginBottom: 0,
                                                              fontSize: 16
                                                            }}
                                                            className="clippable-spacer"
                                                          >
                                                            6-Chakki
                                                          </h4>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td>
                                                          <div
                                                            id="livestat5"
                                                            style={{
                                                              float: "left",
                                                              color: "red"
                                                            }}
                                                          >
                                                            {book6 !== "" ? (
                                                              Number(book6) >
                                                                0 ? (
                                                                <font color="green">
                                                                  {formatTruncate(
                                                                    book6
                                                                  )}
                                                                </font>
                                                              ) : (
                                                                <font color="red">
                                                                  {formatTruncate(
                                                                    book6
                                                                  )}
                                                                </font>
                                                              )
                                                            ) : (
                                                              ""
                                                            )}
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </span>
                                              </div>
                                            </h3>
                                            <div className="price-row-box-new">
                                              <div
                                                className={`runner-disabled2 suspendCls ${isSuspended ? "" : "hides"
                                                  }`}
                                              >
                                                {suspendedText}
                                              </div>
                                              <a className="price-price price-back whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-back whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a
                                                className="price-price price-back mb-show span1details"
                                                data-id="Odd"
                                                data-type="b"
                                                data-sid={5}
                                                data-market-type="f"
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "b",
                                                    "6-Chakki",
                                                    b1
                                                  )
                                                }
                                              >
                                                <div
                                                  id="rnr4"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s08"
                                                  >
                                                    <span>{b1}</span>
                                                  </span>
                                                  <span
                                                    className="price-amount"
                                                    id="rate4"
                                                  >
                                                    {stakeLimit}
                                                  </span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay ml-4 mb-show">
                                                <div
                                                  id="rnr4"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s08"
                                                  ></span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-lay mr-4 whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              {/*<div class="suspended-overlap" id="odds_suspend_runner1">Suspended</div>*/}
                                            </div>
                                          </div>
                                          <div className="runner-runner">
                                            <h3
                                              className={runnerClass(6)}
                                              id="b4Sucess"
                                            >
                                              <div className="runner-info">
                                                <span className="clippable runner-display-name">
                                                  <table>
                                                    <tbody>
                                                      <tr>
                                                        <td>
                                                          <h4
                                                            style={{
                                                              marginBottom: 0,
                                                              fontSize: 16
                                                            }}
                                                            className="clippable-spacer"
                                                          >
                                                            7-Satti
                                                          </h4>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td>
                                                          <div
                                                            id="livestat5"
                                                            style={{
                                                              float: "left",
                                                              color: "red"
                                                            }}
                                                          >
                                                            {book7 !== "" ? (
                                                              Number(book7) >
                                                                0 ? (
                                                                <font color="green">
                                                                  {formatTruncate(
                                                                    book7
                                                                  )}
                                                                </font>
                                                              ) : (
                                                                <font color="red">
                                                                  {formatTruncate(
                                                                    book7
                                                                  )}
                                                                </font>
                                                              )
                                                            ) : (
                                                              ""
                                                            )}
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </span>
                                              </div>
                                            </h3>
                                            <div className="price-row-box-new">
                                              <div
                                                className={`runner-disabled2 suspendCls ${isSuspended ? "" : "hides"
                                                  }`}
                                              >
                                                {suspendedText}
                                              </div>
                                              <a className="price-price price-back whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-back whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a
                                                className="price-price price-back mb-show span1details"
                                                data-id="Odd"
                                                data-type="b"
                                                data-sid={5}
                                                data-market-type="f"
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "b",
                                                    "7-Satti",
                                                    b1
                                                  )
                                                }
                                              >
                                                <div
                                                  id="rnr4"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s08"
                                                  >
                                                    <span>{b1}</span>
                                                  </span>
                                                  <span
                                                    className="price-amount"
                                                    id="rate4"
                                                  >
                                                    {stakeLimit}
                                                  </span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay ml-4 mb-show">
                                                <div
                                                  id="rnr4"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s08"
                                                  ></span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-lay mr-4 whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              {/*<div class="suspended-overlap" id="odds_suspend_runner1">Suspended</div>*/}
                                            </div>
                                          </div>
                                          <div className="runner-runner">
                                            <h3
                                              className={runnerClass(7)}
                                              id="b4Sucess"
                                            >
                                              <div className="runner-info">
                                                <span className="clippable runner-display-name">
                                                  <table>
                                                    <tbody>
                                                      <tr>
                                                        <td>
                                                          <h4
                                                            style={{
                                                              marginBottom: 0,
                                                              fontSize: 16
                                                            }}
                                                            className="clippable-spacer"
                                                          >
                                                            8-Atthi
                                                          </h4>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td>
                                                          <div
                                                            id="livestat5"
                                                            style={{
                                                              float: "left",
                                                              color: "red"
                                                            }}
                                                          >
                                                            {book8 !== "" ? (
                                                              Number(book8) >
                                                                0 ? (
                                                                <font color="green">
                                                                  {formatTruncate(
                                                                    book8
                                                                  )}
                                                                </font>
                                                              ) : (
                                                                <font color="red">
                                                                  {formatTruncate(
                                                                    book8
                                                                  )}
                                                                </font>
                                                              )
                                                            ) : (
                                                              ""
                                                            )}
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </span>
                                              </div>
                                            </h3>
                                            <div className="price-row-box-new">
                                              <div
                                                className={`runner-disabled2 suspendCls ${isSuspended ? "" : "hides"
                                                  }`}
                                              >
                                                {suspendedText}
                                              </div>
                                              <a className="price-price price-back whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-back whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a
                                                className="price-price price-back mb-show span1details"
                                                data-id="Odd"
                                                data-type="b"
                                                data-sid={5}
                                                data-market-type="f"
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "b",
                                                    "8-Atthi",
                                                    b1
                                                  )
                                                }
                                              >
                                                <div
                                                  id="rnr4"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s08"
                                                  >
                                                    <span>{b1}</span>
                                                  </span>
                                                  <span
                                                    className="price-amount"
                                                    id="rate4"
                                                  >
                                                    {stakeLimit}
                                                  </span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay ml-4 mb-show">
                                                <div
                                                  id="rnr4"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s08"
                                                  ></span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-lay mr-4 whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              {/*<div class="suspended-overlap" id="odds_suspend_runner1">Suspended</div>*/}
                                            </div>
                                          </div>
                                          <div className="runner-runner">
                                            <h3
                                              className={runnerClass(8)}
                                              id="b4Sucess"
                                            >
                                              <div className="runner-info">
                                                <span className="clippable runner-display-name">
                                                  <table>
                                                    <tbody>
                                                      <tr>
                                                        <td>
                                                          <h4
                                                            style={{
                                                              marginBottom: 0,
                                                              fontSize: 16
                                                            }}
                                                            className="clippable-spacer"
                                                          >
                                                            9-Nehli
                                                          </h4>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td>
                                                          <div
                                                            id="livestat5"
                                                            style={{
                                                              float: "left",
                                                              color: "red"
                                                            }}
                                                          >
                                                            {book9 !== "" ? (
                                                              Number(book9) >
                                                                0 ? (
                                                                <font color="green">
                                                                  {formatTruncate(
                                                                    book9
                                                                  )}
                                                                </font>
                                                              ) : (
                                                                <font color="red">
                                                                  {formatTruncate(
                                                                    book9
                                                                  )}
                                                                </font>
                                                              )
                                                            ) : (
                                                              ""
                                                            )}
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </span>
                                              </div>
                                            </h3>
                                            <div className="price-row-box-new">
                                              <div
                                                className={`runner-disabled2 suspendCls ${isSuspended ? "" : "hides"
                                                  }`}
                                              >
                                                {suspendedText}
                                              </div>
                                              <a className="price-price price-back whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-back whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a
                                                className="price-price price-back mb-show span1details"
                                                data-id="Odd"
                                                data-type="b"
                                                data-sid={5}
                                                data-market-type="f"
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "b",
                                                    "9-Nehli",
                                                    b1
                                                  )
                                                }
                                              >
                                                <div
                                                  id="rnr4"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s08"
                                                  >
                                                    <span>{b1}</span>
                                                  </span>
                                                  <span
                                                    className="price-amount"
                                                    id="rate4"
                                                  >
                                                    {stakeLimit}
                                                  </span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay ml-4 mb-show">
                                                <div
                                                  id="rnr4"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s08"
                                                  ></span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-lay mr-4 whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              {/*<div class="suspended-overlap" id="odds_suspend_runner1">Suspended</div>*/}
                                            </div>
                                          </div>
                                          <div className="runner-runner">
                                            <h3
                                              className={runnerClass(9)}
                                              id="b4Sucess"
                                            >
                                              <div className="runner-info">
                                                <span className="clippable runner-display-name">
                                                  <table>
                                                    <tbody>
                                                      <tr>
                                                        <td>
                                                          <h4
                                                            style={{
                                                              marginBottom: 0,
                                                              fontSize: 16
                                                            }}
                                                            className="clippable-spacer"
                                                          >
                                                            10-Dassi
                                                          </h4>
                                                        </td>
                                                      </tr>
                                                      <tr>
                                                        <td>
                                                          <div
                                                            id="livestat5"
                                                            style={{
                                                              float: "left",
                                                              color: "red"
                                                            }}
                                                          >
                                                            {book10 !== "" ? (
                                                              Number(book10) >
                                                                0 ? (
                                                                <font color="green">
                                                                  {formatTruncate(
                                                                    book10
                                                                  )}
                                                                </font>
                                                              ) : (
                                                                <font color="red">
                                                                  {formatTruncate(
                                                                    book10
                                                                  )}
                                                                </font>
                                                              )
                                                            ) : (
                                                              ""
                                                            )}
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </span>
                                              </div>
                                            </h3>
                                            <div className="price-row-box-new">
                                              <div
                                                className={`runner-disabled2 suspendCls ${isSuspended ? "" : "hides"
                                                  }`}
                                              >
                                                {suspendedText}
                                              </div>
                                              <a className="price-price price-back whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-back whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a
                                                className="price-price price-back mb-show span1details"
                                                data-id="Odd"
                                                data-type="b"
                                                data-sid={5}
                                                data-market-type="f"
                                                onClick={() =>
                                                  showBetfairBetSlip(
                                                    "b",
                                                    "10-Dassi",
                                                    b1
                                                  )
                                                }
                                              >
                                                <div
                                                  id="rnr4"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s08"
                                                  >
                                                    <span>{b1}</span>
                                                  </span>
                                                  <span
                                                    className="price-amount"
                                                    id="rate4"
                                                  >
                                                    {stakeLimit}
                                                  </span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay ml-4 mb-show">
                                                <div
                                                  id="rnr4"
                                                  className="sus_cls"
                                                >
                                                  <span
                                                    className="price-odd odd"
                                                    id="s08"
                                                  ></span>
                                                </div>
                                              </a>
                                              <a className="price-price price-lay whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              <a className="price-price price-lay mr-4 whtBack hide-mobile">
                                                <div>&nbsp;</div>
                                              </a>
                                              {/*<div class="suspended-overlap" id="odds_suspend_runner1">Suspended</div>*/}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div style={{ height: "5px" }}></div>
                                    <div
                                      style={{
                                        display:
                                          activeTabIndex == 2 ? "" : "none",
                                        color: "white"
                                      }}
                                    >
                                      <DusDamResult resultData={resultData} />
                                    </div>
                                    <div
                                      id="ResultsData"
                                      className="tabcontent"
                                      style={{ display: "none" }}
                                    ></div>
                                  </div>
                                  <div className="col-md-4">
                                    <div
                                      className="accordion"
                                      id="bookmakerExample"
                                      style={{ marginTop: 0, marginBottom: 5 }}
                                    >
                                      <div
                                        className="card"
                                        style={{ border: 0 }}
                                      >
                                        {showBetSlipPopup && (
                                          <TPPopUpBetSlip
                                            closeBetSlipParent={
                                              closeBetSlipMobile
                                            }
                                            betObj={placeBetObject}
                                            placeBetParent={placeBet}
                                            betButtonShow={betButtonShow}
                                            betErrorMessageObj={
                                              betErrorMessageObj
                                            }
                                            betButtonShowLoaderShow={
                                              betButtonShowLoaderShow
                                            }
                                            profileData={profileData}
                                          />
                                        )}
                                        <TeenPattisCasinoBetslipWeb
                                          showBetSlip={showBetSlip}
                                          placeBetObject={placeBetObject}
                                          closeBetSlipParent={closeBetSlip}
                                          placeBetParent={placeBet}
                                          betErrorMessageObj={
                                            betErrorMessageObj
                                          }
                                          profileData={profileData}
                                        ></TeenPattisCasinoBetslipWeb>
                                        <div
                                          className="card-header"
                                          id="headingTwo"
                                          style={{
                                            padding: 0,
                                            background: "#23292d"
                                          }}
                                        >
                                          <h2
                                            className="mb-0"
                                            style={{
                                              background: "var(--theme-color)",
                                              borderRadius: 0
                                            }}
                                          >
                                            <button
                                              className="btn btn-link btn-block text-left"
                                              type="button"
                                              data-toggle="collapse"
                                              data-target="#collapseTwo"
                                              aria-expanded="true"
                                              aria-controls="collapseTwo"
                                              style={{
                                                color: "white",
                                                textDecoration: "none"
                                              }}
                                            >
                                              Matched Bets
                                            </button>
                                          </h2>
                                        </div>
                                        <div
                                          id="collapseTwo"
                                          className="collapse show"
                                          aria-labelledby="headingTwo"
                                          data-parent="#bookmakerExample"
                                          style={{ backgroundColor: "#2e3438" }}
                                        >
                                          <div
                                            className="card-body"
                                            style={{
                                              padding: 0,
                                              minHeight: 40
                                            }}
                                          >
                                            <div
                                              id="refreshhistory"
                                              style={{
                                                paddingLeft: 0,
                                                width: "100%"
                                              }}
                                            >
                                              <table
                                                className="table"
                                                style={{ marginBottom: 0 }}
                                              >
                                                <thead>
                                                  <tr>
                                                    <th>Runner</th>
                                                    <th>Price</th>
                                                    <th>Size</th>
                                                    <th></th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {betList.length > 0 ? (
                                                    betList.map(
                                                      (item, index) => (
                                                        <tr
                                                          style={{
                                                            background:
                                                              item.type == "b"
                                                                ? "#e9f6fc"
                                                                : "#fce3e4",
                                                            color: "#000",
                                                            fontSize: "15px",
                                                            textAlign: "center"
                                                          }}
                                                        >
                                                          <td
                                                            style={{
                                                              textAlign: "left",
                                                              padding: "15px",
                                                              display:
                                                                "table-cell",
                                                              padding: "5px"
                                                            }}
                                                          >
                                                            {item.rnr !== "" ? (
                                                              item.rnr ==
                                                                "b1" ||
                                                                item.rnr ==
                                                                "l1" ? (
                                                                <span>
                                                                  1-Ekka
                                                                </span>
                                                              ) : item.rnr ==
                                                                "b2" ||
                                                                item.rnr ==
                                                                "l2" ? (
                                                                <span>
                                                                  2-Dukki
                                                                </span>
                                                              ) : item.rnr ==
                                                                "b3" ||
                                                                item.rnr ==
                                                                "l3" ? (
                                                                <span>
                                                                  3-Thikki
                                                                </span>
                                                              ) : item.rnr ==
                                                                "b4" ||
                                                                item.rnr ==
                                                                "l4" ? (
                                                                <span>
                                                                  4-Chauki
                                                                </span>
                                                              ) : item.rnr ==
                                                                "b5" ||
                                                                item.rnr ==
                                                                "l5" ? (
                                                                <span>
                                                                  5-Panji
                                                                </span>
                                                              ) : item.rnr ==
                                                                "b6" ||
                                                                item.rnr ==
                                                                "l6" ? (
                                                                <span>
                                                                  6-Chakki
                                                                </span>
                                                              ) : item.rnr ==
                                                                "b7" ||
                                                                item.rnr ==
                                                                "l7" ? (
                                                                <span>
                                                                  7-Satti
                                                                </span>
                                                              ) : item.rnr ==
                                                                "b8" ||
                                                                item.rnr ==
                                                                "l8" ? (
                                                                <span>
                                                                  8-Atthi
                                                                </span>
                                                              ) : item.rnr ==
                                                                "b9" ||
                                                                item.rnr ==
                                                                "l9" ? (
                                                                <span>
                                                                  9-Nehli
                                                                </span>
                                                              ) : item.rnr ==
                                                                "b10" ||
                                                                item.rnr ==
                                                                "l10" ? (
                                                                <span>
                                                                  10-Dassi
                                                                </span>
                                                              ) : (
                                                                <span></span> // For any other value
                                                              )
                                                            ) : (
                                                              <span></span>
                                                            )}
                                                            - ({item.cat_mid})
                                                          </td>
                                                          <td
                                                            style={{
                                                              display:
                                                                "table-cell",
                                                              textAlign: "left",
                                                              padding: "5px"
                                                            }}
                                                          >
                                                            {item.rate}
                                                          </td>
                                                          <td
                                                            style={{
                                                              display:
                                                                "table-cell",
                                                              textAlign: "left",
                                                              padding: "5px"
                                                            }}
                                                          >
                                                            {item.amnt}
                                                          </td>
                                                          <td></td>
                                                        </tr>
                                                      )
                                                    )
                                                  ) : (
                                                    <tr></tr>
                                                  )}
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {/* Open bets end*/}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ClientLayoutWithOutHeader>
      <style>
        {`
            .dus-dum-scope .home-content {
              margin-top: 0 !important;
            }

            .dus-dum-scope .Connectedclients {
              color: #fff;
            }

            .dus-dum-scope .Connectedclients .number {
              color: #fff;
            }

            .dus-dum-scope .tb-content{
              padding-top:3px;
            }

            .dus-dum-scope .cards-layout.blackjack {
              position: relative;
              background: #000000;
              overflow: visible;
            }

            .dus-dum-scope .left-content,
            .dus-dum-scope .table-wrap,
            .dus-dum-scope .ExMainCardbundle {
              overflow: visible;
            }

            .dus-dum-scope .cards-layout.blackjack.dus-dum-game {
              min-height: 265px !important;
              padding-bottom: 12px;
              display: flex !important;
              flex-direction: column !important;
              align-items: center !important;
            }

            .dus-dum-scope .cards-layout.blackjack.dus-dum-game .dus-dum-timer-wrap {
              width: 100%;
              margin-bottom: 0 !important;
            }

            .dus-dum-scope .cards-layout.blackjack.dus-dum-game .dus-dum-timer-wrap .col-md-2 {
              top: 14px !important;
              right: 2px !important;
            }

            .dus-dum-scope .ExMainCardbundle .blackjack.dus-dum-game > .player.dus-dum-winner,
            .dus-dum-scope .cards-layout.blackjack.dus-dum-game > .player.dus-dum-winner {
              margin: 0 !important;
              padding-top: 25px !important;
              display: flex !important;
              flex-direction: column !important;
              align-items: center !important;
              width: 100%;
            }

            .dus-dum-scope .cards-layout.blackjack .player,
            .dus-dum-scope .cards-layout.blackjack .player-item,
            .dus-dum-scope .cards-layout.blackjack .player-cards,
            .dus-dum-scope .cards-layout.blackjack .BFBCardHandView,
            .dus-dum-scope .cards-layout.blackjack .BFBCardFanView {
              overflow: visible;
            }

            .dus-dum-scope .cards-layout.blackjack::before {
              content: "";
              position: absolute;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              background: radial-gradient(
                ellipse 100% 44% at 50% calc(30% + 35px),
                rgba(62, 193, 65, 0.95) 0%,
                rgba(62, 193, 65, 0.8) 15%,
                rgba(30, 80, 35, 0.5) 40%,
                #1e1e1e 55%,
                #1e1e1e 100%
              );
              opacity: 0.4;
              pointer-events: none;
              z-index: 0;
            }

            .dus-dum-scope .cards-layout.blackjack > * {
              position: relative;
              z-index: 1;
            }

            .dus-dum-scope .timerDiv2 .col-md-2 {
              position: relative;
              top: -15px;
              right: -12px;
            }

            .dus-dum-scope .timerDiv2 > .footer-divbpg {
              margin-top: 2px;
            }

            .dus-dum-scope .timerDiv2 > .footer-divbpg .titlebarname {
              text-align: left !important;
              text-align-last: left !important;
            }

            .dus-dum-scope .timerDiv2 > .footer-divbpg .titlebarname p {
              text-align: left !important;
              margin: 0;
              padding-left: 8px;
            }

            .dus-dum-scope .timerDiv2 > .footer-divbpg .titlebarname.Gameidcol {
              text-align: left !important;
              text-align-last: left !important;
            }

            .dus-dum-scope center > .footer-divbpg {
              position: relative;
              z-index: 2;
              margin-top: 10px;
              background: linear-gradient(180deg, #464646, #0f0f0f);
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              min-height: 45px;
              border: 2px solid;
              border-image-slice: 1 !important;
              border-image-source: linear-gradient(
                180deg,
                rgba(207, 141, 46, 0.47),
                #cf8d2e 50%,
                rgba(207, 141, 46, 0.47)
              );
              box-sizing: border-box;
            }

            .dus-dum-scope center {
              display: block;
              width: 100%;
            }

            .dus-dum-scope center > .footer-divbpg .buttons-div {
              align-items: center;
              display: flex;
              flex-direction: row;
              flex: 1;
              height: 100%;
              overflow-x: auto;
            }

            .dus-dum-scope center > .footer-divbpg .video-button {
              padding: 0;
              background-color: #4f4f4f !important;
              color: #fff !important;
              font-size: 12px !important;
              font-weight: 500;
              height: 35px !important;
              min-width: 35px !important;
              width: auto !important;
              margin-right: 3px;
              text-align: center;
              border: none;
              border-bottom: 1px solid #1a1a1a !important;
              border-right: 1px solid #1a1a1a !important;
              border-radius: 0 !important;
              flex-shrink: 0;
              pointer-events: none;
            }

            .dus-dum-scope center > .footer-divbpg .round-div {
              margin-right: 4px;
              color: #fff;
              display: flex;
              flex-direction: column;
              font-size: 11px;
              justify-content: center;
              white-space: nowrap;
              flex-shrink: 0;
            }

            .dus-dum-scope center > .footer-divbpg .round-div .label {
              color: rgba(255, 255, 255, 0.85);
            }

            .dus-dum-scope .tp20-sound-wrap {
              position: relative;
              height: 0;
              margin-top: -40px;
              z-index: 4;
            }

            .dus-dum-scope .tp20-sound-wrap .sound-icon {
              position: absolute;
              right: 18px;
              top: -18px;
              cursor: pointer;
              color: #fff;
              z-index: 4;
              width: 15px;
              height: 15px;
              font-size: 15px;
              line-height: 15px;
              display: inline-flex;
              align-items: center;
              justify-content: center;
            }

            @media (min-width:992px){
              .dus-dum-scope .row{
                margin-left:0 !important;
                margin-right:0 !important;
              }

              /*.dus-dum-scope .col-md-8{
                padding-left:19px !important;
                margin-bottom:9px;
              }*/

              .dus-dum-scope .left-content{
                padding-right:6px;
              }

              .dus-dum-scope .col-12{
                padding-left:0 !important;
                padding-right:0 !important;
              }

              .dus-dum-scope .left-content .market-titlebar {
                width: 100%;
                display: flex;
                height: 20px;
              }

              .dus-dum-scope .runner-runner .lobby-btn {
                height: 38px !important;
                min-height: 38px !important;
                padding: 2px 4px !important;
              }

              .dus-dum-scope .cards-layout.blackjack {
                min-height: 260px;
              }

              .dus-dum-scope .cards-layout.blackjack.dus-dum-game {
                min-height: 265px;
              }

              .dus-dum-scope .volume-wrapper {
                margin-top: -35px;
              }
            }

            @media (max-width:991px){
              .dus-dum-scope .market-titlebar strong{
                font-size:13px;
              }


              .dus-dum-scope .left-content{
                padding-right:0;
              }
            }

            @media (max-width:768px){
              .dus-dum-scope .cards-layout.blackjack {
                min-height: 220px !important;
              }

              .dus-dum-scope .cards-layout.blackjack.dus-dum-game {
                min-height: 265px !important;
              }

              .dus-dum-scope .timerDiv2 {
                margin-bottom: 0 !important;
              }

              .dus-dum-scope .timerDiv2 .col-md-2 {
                top: -6px;
              }

              .dus-dum-scope .timerDiv2 .footer-divbpg {
                margin-top: 0 !important;
              }

              .dus-dum-scope .volume-wrapper {
                margin-top: 0 !important;
              }
            }

            .dus-dum-scope .player:not(.dus-dum-winner) {
              margin: 4px;
              display: inline-block;
              justify-content: space-between;
              flex: 1 0 0;
              flex-wrap: wrap;
            }
            .dus-dum-scope .player-item {
              margin-bottom: 16px;
              display: block;
              margin-right: 0;
              z-index: 0;
            }
            .dus-dum-scope .player-item .name {
              display: block;
              color: #d7bc7b;
              font-size: 12px;
              font-weight: 700;
              padding-bottom: 5px;
              text-align: center;
            }
            .dus-dum-scope .player-item .player-cards {
              border-radius: 12px;
              border: 1px solid rgba(178, 220, 175, .25);
            }
            .dus-dum-scope .ExMainCardbundle .BFBCardHandView {
              transform: translate3d(0, 0, 0);
              width: 100px;
              height: 105px;
              margin-top: 5px;
              margin-bottom: 5px;
            }
            .dus-dum-scope #refreshhistory .table thead th {
              padding: 5px;
              color: #2b2f35;
              background: #ddd;
            }
            .dus-dum-scope .ExMainCardbundle .card1 {
              left: 14.9352px;
            }
            .dus-dum-scope .player-dt {
              display: flex !important;
              flex-direction: column;
              align-items: center !important;
              max-width: none;
              width: auto;
              color: #d7bc7b !important;
              font-size: 12px;
              font-weight: 700;
            }
            .dus-dum-scope .stood{
              height: 110px;
              width: 170px;
            }
            .dus-dum-scope .ExMainCardbundle .card1 {
              position: absolute;
              left: 42.9352px;
              top: 0px !important;
              width: 69px;
              height: 98px;
            }

              /* mobile */  
            @media (max-width:576px){

            .mob-margin{
              padding-right: 0px !important;
              padding-left: 0px !important;
            }

                .Exgamesbg {
        padding-left: 5px !important;
        padding-right: 5px !important;
    }
              .dus-dum-scope .cards-layout.blackjack.dus-dum-game {
                min-height: 265px !important;
              }
              .dus-dum-scope .cards-layout.blackjack:not(.dus-dum-game) {
                min-height: 200px !important;
              }
              .dus-dum-scope .show-mobile.dus-dum-game{
                height: auto !important;
                min-height: 265px;
                overflow: visible;
              }
              .dus-dum-scope .show-mobile:not(.dus-dum-game){
                height: auto !important;
                min-height: 200px;
                overflow: visible;
              }
              .dus-dum-scope .stood{
                height: 110px;
                width: 170px;
              }
              .dus-dum-scope .titlebarname p{
                font-size: 14px;
              }
              .dus-dum-scope .cards-layout.blackjack .col-12{
                padding-left:0;
                padding-right:0;
              }
              .dus-dum-scope .volume-wrapper {  
                height: 10px !important;
                margin-top: -7px !important;
                line-height: 16px;
                margin-bottom: 10px;
              }
              .dus-dum-scope .bt-mobile {
                width: 100%;
                display: flex;
                justify-content: flex-end;
              }
              .dus-dum-scope .timerDiv2 > .col-md-2 {
                display: flex;
                justify-content: flex-end;
                padding-right: 0 !important;
              }
              .dus-dum-scope .cards-layout.blackjack.dus-dum-game .dus-dum-timer-wrap .col-md-2 {
                top: -5px !important;
              }
              .dus-dum-scope .base-timer__svg {
                width: 50px;
                height: 50px;
              }
              .dus-dum-scope .ExMainCardbundle .card1 {
                height: 100px;
                left: 1px;
                top: 0px;
              }
              .dus-dum-scope .RSMImageView {
                position: absolute !important;
                left: 95% !important;
                margin-top: -7px;
                transform: translateX(-50%) !important;
                width: 132% !important;
                height: 68% !important;
              }
              .dus-dum-scope .price-row-box-new {
                position: relative;
              }
              .dus-dum-scope .runner-disabled2 {
                position: absolute;
                inset: 0; 
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 9999;
                background: rgba(200, 200, 200, 0.95);
              }
              .dus-dum-scope .hide-mobile {
                display: none !important;
              }
              .dus-dum-scope .footer-divbpg{
                display:flex;
                align-items:center;
                justify-content:space-between;
                flex-wrap:nowrap; 
                border-radius:8px;
              }
              .dus-dum-scope .btn-group-sm .btn{
                padding:2px 6px;
                font-size:12px;
              }
              .dus-dum-scope .btn-group{
                flex-wrap:nowrap !important;
              }
              .dus-dum-scope .footer-divbpg .btn-group-sm .btn{
                padding:6px 4px !important;
                font-size:12px !important;
                line-height:1.2;
                margin-top: 0;
              }
              .dus-dum-scope .footer-divbpg .titlebarname {
                flex: 1;
                max-width: none !important;
                padding-left: 4px;
                text-align: left !important;
                text-align-last: left !important;
              }
              .dus-dum-scope .titlebarname p {
                font-size: 17px !important;
                margin: 0;
                margin-bottom: 12px;
                margin-left: 18px;
                text-align: left !important;
              }
              @scope (.dus-dum-scope) {
                center > .footer-divbpg .video-button {
                  padding: 0;
                  background-color: #4f4f4f !important;
                  color: #fff !important;
                  font-size: 12px !important;
                  font-weight: 500;
                  height: 35px !important;
                  min-width: 35px !important;
                  width: auto !important;
                  margin-right: 3px;
                  text-align: center;
                  border-radius: 0 !important;
                  border-bottom: 1px solid #1a1a1a !important;
                  border-right: 1px solid #1a1a1a !important;
                }
              }
            }
        `}
      </style>
    </div>
  );
}
